const supraxData = {
  slug: "supra-x",
  name: "Honda Supra X 125 FI",

  hero: {
    shortDescription:
      "Motor bebek legendaris 125cc yang irit, tangguh, dan nyaman untuk penggunaan harian",

    variants: [
      {
        key: "sw-quantum-black",
        label: "Spoke Wheel",
        fullName: "Honda Supra X 125 FI SW Quantum Black",
        startPrice: 21544000,
      },
      {
        key: "cw-energetic-red",
        label: "Cast Wheel",
        fullName: "Honda Supra X 125 FI CW Energetic Red",
        startPrice: 22569000,
      },
      {
        key: "cw-golden-matte-black",
        label: "Cast Wheel",
        fullName: "Honda Supra X 125 FI CW Golden Matte Black",
        startPrice: 22569000,
      },
    ],

    slides: [
      {
        variantKey: "sw-quantum-black",
        image: "/assets/motor/produk/suprax/SupraX-Quantum-Black-SW.webp",
        specs: {
          engine: "124,89 cc",
          transmission: "Manual 4 Percepatan",
          feature: "PGM-FI",
        },
      },
      {
        variantKey: "cw-energetic-red",
        image: "/assets/motor/produk/suprax/SupraX-Energetic-Red-CW.webp",
        specs: {
          engine: "124,89 cc",
          transmission: "Manual 4 Percepatan",
          feature: "PGM-FI",
        },
      },
      {
        variantKey: "cw-golden-matte-black",
        image: "/assets/motor/produk/suprax/SupraX-Golden-Matte-Black-CW.webp",
        specs: {
          engine: "124,89 cc",
          transmission: "Manual 4 Percepatan",
          feature: "PGM-FI",
        },
      },
    ],
  },

  description: {
    sections: [
      {
        type: "paragraph",
        text:
          "Honda Supra X 125 FI merupakan motor bebek legendaris yang dikenal dengan keiritan bahan bakar dan daya tahan tinggi.",
      },
      {
        type: "paragraph",
        text:
          "Dibekali mesin 125cc berteknologi PGM-FI, Supra X 125 FI menawarkan performa halus dan efisiensi optimal.",
      },
      {
        type: "heading",
        text: "Irit & Andal",
      },
      {
        type: "paragraph",
        text:
          "Sistem injeksi PGM-FI memastikan konsumsi bahan bakar lebih efisien dan ramah lingkungan.",
      },
      {
        type: "heading",
        text: "Nyaman untuk Harian",
      },
      {
        type: "paragraph",
        text:
          "Posisi berkendara ergonomis dan suspensi empuk membuat Supra X 125 FI nyaman digunakan setiap hari.",
      },
    ],
  },

  specificationsDetail: {
    mesin: [
      ["Tipe Mesin", "4 Langkah, SOHC, Silinder Tunggal"],
      ["Kapasitas Mesin", "124,89 cc"],
      ["Sistem Pendingin", "Pendingin Udara"],
      ["Sistem Suplai Bahan Bakar", "PGM-FI"],
      ["Daya Maksimum", "7,4 kW / 8.000 rpm"],
      ["Torsi Maksimum", "9,3 Nm / 4.000 rpm"],
      ["Transmisi", "Manual, 4 Percepatan"],
    ],

    rangka: [
      ["Tipe Rangka", "Underbone"],
      ["Suspensi Depan", "Teleskopik"],
      ["Suspensi Belakang", "Lengan Ayun dengan Suspensi Ganda"],
      ["Rem Depan", "Cakram"],
      ["Rem Belakang", "Tromol"],
    ],

    dimensi: [
      ["Panjang x Lebar x Tinggi", "1.918 x 709 x 1.101 mm"],
      ["Jarak Sumbu Roda", "1.235 mm"],
      ["Tinggi Jok", "770 mm"],
      ["Berat", "103 kg (SW) / 104 kg (CW)"],
    ],

    kapasitas: [
      ["Kapasitas Tangki Bahan Bakar", "4,0 Liter"],
      ["Kapasitas Bagasi", "7 Liter"],
    ],

    kelistrikan: [
      ["Sistem Pengapian", "Full Transistorized"],
      ["Panel Meter", "Analog"],
      ["Lampu Depan", "Halogen"],
    ],
  },

  fullFeatures: {
    title: "Fitur Unggulan Honda Supra X 125 FI",
    items: [
      {
        title: "Mesin 125cc PGM-FI",
        desc:
          "Irit bahan bakar dengan performa halus dan ramah lingkungan.",
      },
      {
        title: "Secure Key Shutter",
        desc:
          "Sistem pengaman lubang kunci untuk mencegah pencurian.",
      },
      {
        title: "Bagasi Luas",
        desc:
          "Bagasi 7 liter untuk menyimpan barang bawaan.",
      },
      {
        title: "Panel Meter Informatif",
        desc:
          "Panel analog yang mudah dibaca saat berkendara.",
      },
      {
        title: "Rem Cakram Depan",
        desc:
          "Pengereman lebih optimal dan aman.",
      },
      {
        title: "Rangka Underbone Kuat",
        desc:
          "Tangguh dan stabil untuk penggunaan jangka panjang.",
      },
    ],
  },
};

export default supraxData;
